var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7214 0.477995C18.8349 -0.380586 20.9552 1.68663 20.0746 3.74723L13.999 17.9637C12.8108 20.7439 8.63136 20.274 8.12348 17.303L7.36549 12.8689L2.81755 12.1299C-0.229723 11.6348 -0.711728 7.55996 2.13994 6.40151L16.7214 0.477995ZM18.181 2.978C18.3572 2.56588 17.9331 2.15243 17.5104 2.32415L2.92892 8.24767C1.97837 8.63382 2.13904 9.99208 3.15479 10.1571L7.70273 10.8962C8.56732 11.0366 9.24484 11.6972 9.38893 12.5401L10.1469 16.9742C10.3162 17.9646 11.7094 18.1212 12.1054 17.1944L18.181 2.978Z",
    fill: "#B1B5C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSend);
export default __webpack_public_path__ + "static/media/arrow-send.c0a0b5575894f464df2be915bd2f4473.svg";
export { ForwardRef as ReactComponent };